import tdLocalStorage from "../../../tdLocalStorage";

/**
 * Manage mobile notifications
 * - emit user api_auth params to IOS and Android mobile app
 */
export default class tdMobileNotificationsUtil {

    //NOTE - make sure this parameter matches the one inside the swift app
    static _tdUserLoginEvent = 'td_user_login';
    static _tdUserLogoutEvent = 'td_user_logout';

    static sendLoginEvent() {
        let rememberLogin = tdLocalStorage.get('td_remember_login_new');

        this.sendLoginEventIOS(rememberLogin.session_company_id, rememberLogin.session_token);
    }
    static sendLogoutEvent() {
        let rememberLogin = tdLocalStorage.get('td_remember_login_new');

        if (rememberLogin) {
            this.sendLogoutEventIOS(rememberLogin.session_company_id, rememberLogin.session_token);
        }
    }

    static sendLoginEventIOS(sessionCompanyId, sessionToken) {
        let tdEvent = tdMobileNotificationsUtil._tdUserLoginEvent;

        // Check if `webkit` and `messageHandlers` are available
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[tdEvent]) {
            // Prepare the message data
            let messageData = {
                session_company_id: sessionCompanyId,
                session_token: sessionToken
            };

            // Post the message
            window.webkit.messageHandlers[tdEvent].postMessage(messageData);
        } else {
            console.error("sendLoginEventIOS - IOS Notifications - The native context does not exist or the handler is not registered.");
        }
    }
    static sendLogoutEventIOS(sessionCompanyId, sessionToken) {
        let tdEvent = tdMobileNotificationsUtil._tdUserLogoutEvent;

        // Check if `webkit` and `messageHandlers` are available
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[tdEvent]) {
            // Prepare the message data
            let messageData = {
                session_company_id: sessionCompanyId,
                session_token: sessionToken
            };

            // Post the message
            window.webkit.messageHandlers[tdEvent].postMessage(messageData);
        } else {
            console.error("sendLogoutEventIOS - IOS Notifications - The native context does not exist or the handler is not registered.");
        }
    }
}





// WEBPACK FOOTER //
// ./src/components/userNotifications/components/tdMobileNotificationsUtil.js